import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import CustomerSelect from "../common/CustomerSelect";
import StatusMultiSelect from "../common/StatusMultiSelect";
import AlternativeNamesSelect from "../common/AlternativeNamesSelect";

const MaintenanceFiltersForm = ({ filters, onChange }) => (
  <React.Fragment>
    <Row className="form-group">
      <Col md={3}>
        <CustomerSelect
          isMulti
          label="Customer"
          placeholder="Select a Customer"
          value={filters.name || []}
          onChange={(e) => onChange("name", e || [])}
        />
      </Col>
      <Col md={3}>
        <AlternativeNamesSelect
          values={filters.alternative_names}
          name="alternative_names"
          onChange={onChange}
        />
      </Col>
      <Col md={3}>
        <StatusMultiSelect
          values={filters.status}
          name="status"
          onChange={onChange}
        />
      </Col>
    </Row>
  </React.Fragment>
);

MaintenanceFiltersForm.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func
};

export default MaintenanceFiltersForm;
